import { useLang } from '@inflearn/i18n-tools';
import {
  API_ENDPOINT,
  type ClientApiV1ReviewsCourseUserUserIdReceivedQueryString,
  useClientApiV1ReviewsCourseUserUserIdReceivedQuery,
} from '../../../../../../resources/@types/uccSchema';
import { generateQueryKeyUrl } from '../../../../../utils/generateQueryKeyUrl';

type Params = {
  userId: string;
  queryParams: ClientApiV1ReviewsCourseUserUserIdReceivedQueryString;
  options?: Parameters<typeof useClientApiV1ReviewsCourseUserUserIdReceivedQuery>[0]['options'];
};

export default function useReviewsCourseUserIdReceivedQuery({
  userId,
  queryParams,
  options,
}: Params) {
  const { lang } = useLang();
  const queryOptions = getUseReviewsCourseUserIdReceivedQueryOptions(userId, {
    ...queryParams,
    lang,
  });

  return useClientApiV1ReviewsCourseUserUserIdReceivedQuery({
    ...queryOptions,
    options,
  });
}

export const getUseReviewsCourseUserIdReceivedQueryOptions = (
  userId: string,
  queryParams: ClientApiV1ReviewsCourseUserUserIdReceivedQueryString,
) => {
  return generateQueryKeyUrl({
    url: API_ENDPOINT.CLIENT_V1_REVIEWS_COURSE_USER_USERID_RECEIVED(String(userId)),
    queryParams: {
      ...queryParams,
    },
  });
};
